import { images } from "@/data/images";
import { Grid, ImageList, ImageListItem } from "@mui/material";
import { BrowserView, MobileView } from "react-device-detect";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Header } from "@/layout";
import Image from "mui-image";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export const ProductsPage = () => {
  let { start } = useParams<"start">();
  let selected = 0;
  if (start !== undefined) {
    selected = parseInt(start, 10);
  }
  const [value, setValue] = useState(selected);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Header />
      <BrowserView>
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: "background.paper",
            display: "flex",
            height: "100vh",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="La ligne de produits"
                sx={{ borderRight: 1, borderColor: "divider", height: "100vh" }}
              >
                {images.map((item, index) => (
                  <Tab
                    label={item.name}
                    {...a11yProps(index)}
                    key={item.name}
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid item xs={10}>
              {images.map((item, index) => (
                <TabPanel value={value} index={index} key={index}>
                  <ImageList variant="masonry" cols={3} gap={8}>
                    {item.images.map((image, index2) => (
                      <Link
                        to={`/product/${index}/${index2}`}
                        key={`product-${index}-${index2}`}
                      >
                        <ImageListItem key={image}>
                          <Image src={image} alt={`${item.name} - ${index2}`} />
                        </ImageListItem>
                      </Link>
                    ))}
                  </ImageList>
                </TabPanel>
              ))}
            </Grid>
          </Grid>
        </Box>
      </BrowserView>
      <MobileView>
        <Tabs
          scrollButtons={true}
          allowScrollButtonsMobile
          className="bottom-tabs"
          value={value}
          onChange={handleChange}
          variant="scrollable"
          aria-label="scrollable force tabs example"
        >
          {images.map((item) => (
            <Tab label={item.name} key={item.name} />
          ))}
        </Tabs>
        {images.map((item, index) => (
          <TabPanel value={value} index={index} key={index}>
            <ImageList variant="masonry" cols={1} gap={8}>
              {item.images.map((image, index2) => (
                <Link
                  to={`/product/${index}/${index2}`}
                  key={`product-${index}-${index2}`}
                >
                  <ImageListItem key={image}>
                    <img
                      src={image}
                      alt={`${item.name} - ${index2}`}
                      loading="lazy"
                    />
                  </ImageListItem>
                </Link>
              ))}
            </ImageList>
          </TabPanel>
        ))}
      </MobileView>
    </>
  );
};
